import { render, staticRenderFns } from "./DocumentFileUpload.vue?vue&type=template&id=04996048&scoped=true&"
import script from "./DocumentFileUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFileUpload.vue?vue&type=style&index=0&id=04996048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04996048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04996048')) {
      api.createRecord('04996048', component.options)
    } else {
      api.reload('04996048', component.options)
    }
    module.hot.accept("./DocumentFileUpload.vue?vue&type=template&id=04996048&scoped=true&", function () {
      api.rerender('04996048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DocumentFileUpload.vue"
export default component.exports